/* eslint-disable flowtype/require-valid-file-annotation */

import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import $ from "jquery";
import {Typography} from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";

const styles = theme => ({
    hourEntryName: {
        lineHeight: "1.1em",
    },
    hourEntryContact: {},
    raster: {},
    day: {},
    hour: {
        position: "relative",
        lineHeight: "",
        zIndex: 1
    },
    hourRasterDense: {},
    hourRasterWide: {},
    hourEntry: {
        paddingLeft: theme.spacing.unit,
        position: "relative",
        zIndex: 3,
    },
    secondHourType: {
        position: "absolute",
        width: "50%",
        height: "100%",
        top: 0,
        right: 0,
        zIndex: 2,
        clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 10% 100%)"
    }
});

class HoursHour extends React.PureComponent {

    // HoursHour is a PureCompoment:
    // in HourHelper#combineHoursArrays we always create a new reference for the hour, if something changes in the hour

    render() {
        const {classes} = this.props;
        const that = this;
        const hourHeightClass = this.props.dense ? classes.hourRasterDense : classes.hourRasterWide;
        let hourEntriesRendered = null;
        let allNames = "";
        let withTooltip = false;
        let firstHourColor = null;
        let otherHourColor = null;
        if (this.props.hourEntries != null && this.props.hourEntries !== undefined) {
            const length = Object.keys(this.props.hourEntries).length;
            let renderedEntries = 0;
            hourEntriesRendered = $.map(this.props.hourEntries, (entry, entryNumber) => {
                if (renderedEntries >= 3 || entry == null)
                    return;

                renderedEntries++;
                let style = {};
                let hourColor = null;
                if (that.props.hourTypes != null) {
                    let hourTypeObject = that.props.hourTypes.find((hourType) => {
                        return hourType.hourType == entry.type;
                    });
                    hourColor = hourTypeObject != null ? hourTypeObject.color : "#FFF"; //fallback to white
                }
                if (renderedEntries === 1) {
                    firstHourColor = hourColor;
                }
                if (renderedEntries === 2 || renderedEntries === 3) {
                    if(firstHourColor != hourColor) {
                        style = {textAlign: "right"};
                        otherHourColor = hourColor;
                    }
                }
                return <div className={classes.hourEntry} key={entryNumber}>
                    <Typography className={classes.hourEntryName} variant="body1" style={style}>{entry.name != null ? entry.name : ""}</Typography>
                    {entry.contact != undefined && entry.contact != null && entry.contact !== "" ?
                        <Typography key="contact" variant="caption" className={classes.hourEntryContact}>{entry.contact}</Typography> : null}
                </div>
            });
            if (length >= 2) {
                if (length >= 4) {
                    withTooltip = true;
                    const firstEntry = hourEntriesRendered[0];
                    const secondEntry = hourEntriesRendered[1];
                    const otherEntriesSum = <div className={classes.hourEntry} key={-1}>
                        <Typography className={classes.hourEntryName} variant="body1">
                            {"und " + (length - 2) + " weitere..."}
                        </Typography>
                    </div>
                    hourEntriesRendered = [firstEntry, secondEntry, otherEntriesSum];
                }
                hourEntriesRendered[hourEntriesRendered.length] = <div className={classes.secondHourType} style={{backgroundColor: otherHourColor}}/>

                $.each(this.props.hourEntries, (index, entry) => allNames = "" + allNames + (entry != null ? entry.name : "") + ", ");
            }
        }
        const hours = <div className={classes.hour + " " + hourHeightClass + " " + classes.raster} style={{backgroundColor: firstHourColor}}
                         onClick={this.props.onClick} onMouseEnter={this.props.onHover}>{hourEntriesRendered}</div>;

        if (withTooltip){
            return <Tooltip title={allNames} placement={this.props.hourNumber > 15 ? "top" : "bottom"}>{hours}</Tooltip>
        }
        return hours;
    }
}

HoursHour.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(HoursHour, {name: "hourPanel"});